import { SegmentedControl } from '@radix-ui/themes';
import { StatsApiManualFormMode } from 'enums/forms';
import { t } from 'i18next';
import { useAuthStore } from 'stores/use-auth-store';

export const StatsApiVsManualToggle = (props: {
  mode: StatsApiManualFormMode;
  onChange: (v: StatsApiManualFormMode) => void;
}) => {
  const current = useAuthStore((s) => s.current);

  if (!current.mlb_stats_api) {
    return null;
  }

  return (
    <SegmentedControl.Root
      size="1"
      value={props.mode}
      onValueChange={(v) => props.onChange(v as StatsApiManualFormMode)}
      style={{ width: '100%' }}
    >
      <SegmentedControl.Item value={StatsApiManualFormMode.StatsAPI}>
        {t('common.stats-api')}
      </SegmentedControl.Item>
      <SegmentedControl.Item value={StatsApiManualFormMode.Manual}>
        {t('common.manual')}
      </SegmentedControl.Item>
    </SegmentedControl.Root>
  );
};
